import {
  MODAL__HIDE,
  MODAL__PUSH,
  MODAL__REMOVE,
  MODAL__SHOW,
  MODAL__SURVEY_SHARE,
} from '../constants';

export const modalPush = (payload) => ({
  type: MODAL__PUSH,
  payload,
});
export const modalRemove = (payload) => ({
  type: MODAL__REMOVE,
  payload,
});

const modalShow = (modalName, data) => ({
  type: MODAL__SHOW,
  payload: { ...data, modalName },
});

export const modalHide = { type: MODAL__HIDE };

export const modalShowSurveyShare = (data) => modalShow(MODAL__SURVEY_SHARE, data);
